import {
  ActionBar as ActionBarUI,
  ChakraBox,
  ChakraFlex,
  FAIconName,
  FireflyButton,
  Text,
} from '@equip.health/ui';

import {
  AVAILABILITY_EDIT_TEXT,
  EDIT_AVAILABILITY_LABEL,
} from '~/lib/constants/calendar.constants';

import { getTimeZoneOnly } from '~/lib/util/calendar.util';

const TOP_LEVEL_ID = 'availability-rules__action-bar';

interface ActionBarProps {
  handleEditClick: () => void;
  handleSaveClick: () => Promise<void>;
  hasUnsavedChanges: boolean;
  timezone: string;
}

const ActionBar = ({
  handleEditClick,
  handleSaveClick,
  hasUnsavedChanges,
  timezone,
}: ActionBarProps) => {
  const renderNoUnsavedChanges = () => {
    return (
      <ChakraFlex align="center" gap="24px" margin="6px 0px">
        <Text color="primary.100" variant="bodyMedium">
          {getTimeZoneOnly(timezone)}
        </Text>
        <FireflyButton
          id={`${TOP_LEVEL_ID}__edit`}
          leftIcon={FAIconName.penRegular}
          onClick={handleEditClick}
        >
          {EDIT_AVAILABILITY_LABEL}
        </FireflyButton>
      </ChakraFlex>
    );
  };

  const renderUnsavedChanges = () => {
    return (
      <ChakraBox width="100%">
        <ActionBarUI
          barIcon={FAIconName.exclamationCircleRegular}
          buttonIcon={FAIconName.checkRegular}
          buttonText="Save changes"
          id="timezone-edit"
          onButtonClick={() => handleSaveClick?.()}
          text={AVAILABILITY_EDIT_TEXT}
          variant="warning"
        />
      </ChakraBox>
    );
  };

  const justifyContent = !hasUnsavedChanges ? 'flex-end' : 'flex-start';
  return (
    <ChakraBox>
      <ChakraFlex align="center" justifyContent={justifyContent}>
        {hasUnsavedChanges ? renderUnsavedChanges() : renderNoUnsavedChanges()}
      </ChakraFlex>
    </ChakraBox>
  );
};

export default ActionBar;
